import { WebConfigFuncionalidadeRotinaResponse } from './../../../../shared/models/webConfigFuncionalidadeRotinaResponse.model';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { WebIntegrPerfilFuncADOService } from 'app/main/content/shared/services/webIntegrPerfilFuncADO.service';
import { WebIntegrPerfilFuncADO } from 'app/main/content/shared/models/webIntegrPerfilFuncADO.model';
import { PlanoService } from 'app/main/content/shared/services/plano.service';
import { Plano } from 'app/main/content/shared/models/plano.model';
import { WebIntegrPerfilADOService } from 'app/main/content/shared/services/webIntegrPerfilADO.service';
import { WebIntegrFuncionalidadeADOService } from 'app/main/content/shared/services/webIntegrFuncionalidadeADO.service';
import { WebIntegrPerfilADO } from 'app/main/content/shared/models/webIntegrPerfilADO.model';
import { WebIntegrFuncionalidadeADO } from 'app/main/content/shared/models/webIntegrFuncionalidadeADO.model';
import { MatSelect, MatOption, MatPaginator, MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { WebConfigFuncionalidadeRotinaService } from 'app/main/content/shared/services/webConfigFuncionalidadeRotina.service';



@Component({
  selector: 'app-insert.dialog',
  templateUrl: '../../dialogs/insert/insert.dialog.html',
  styleUrls: ['../../dialogs/insert/insert.dialog.scss']
})


export class InsertDialogMensagemFuncionalidadeComponent implements OnInit {

  listaPlano: Plano[] = [];
  listaPerfil: WebIntegrPerfilADO[] = [];
  listaFuncionalidade: WebIntegrFuncionalidadeADO[] = [];
  loading = false;



  constructor(public dialogRef: MatDialogRef<InsertDialogMensagemFuncionalidadeComponent>,
              @Inject(MAT_DIALOG_DATA) public data: WebConfigFuncionalidadeRotinaResponse,
              public webConfigFuncionalidadeRotinaService: WebConfigFuncionalidadeRotinaService,
              private webIntegrFuncionalidadeADOService : WebIntegrFuncionalidadeADOService,
              private planoService: PlanoService,
              private webIntegrPerfilADOService: WebIntegrPerfilADOService) { }

  formControl = new FormControl('', [
    Validators.required
    // Validators.email,
  ]);

  ngOnInit() {
    this.planoService.getAll().subscribe(obj => this.listaPlano = obj);
    this.webIntegrPerfilADOService.getAll().subscribe(obj => this.listaPerfil = obj);
    this.webIntegrFuncionalidadeADOService.getAll().subscribe(obj => this.listaFuncionalidade = obj);
  }

  getErrorMessage() {
    return this.formControl.hasError('required') ? 'Required field' :
      this.formControl.hasError('email') ? 'Not a valid email' :
        '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmInsert(): void {
    //this.loading = true;
  
    this.webConfigFuncionalidadeRotinaService.listInsertData(this.data);

    //this.loading = false;
  }

}

